import {TradingAccount_TradingAccountParameter } from '../proto/generated/trading-bridge'
import { getBrokerLoginUrl } from '../services/apis/tradingAccount'
import { getRedirectUrl } from './authentication'
import { Params } from '../proto/generated/common'
import { convertMapToKeyValueArray } from './common'

export enum BrokerId {
    ANGEL_ONE = 'ANGEL_ONE',
    UPSTOX = 'UPSTOX',   
    FYERS = 'FYERS',
    PAPER_TRADING = 'PAPER_TRADING',
    ZERODHA = 'ZERODHA',
    BROKER_UNKNOWN = 'BROKER_UNKNOWN',
    DHAN = 'DHAN',
    UNRECOGNIZED = 'UNRECOGNIZED'
}

export const getBrokerId = (brokerCode: string): BrokerId => {
    switch (brokerCode) {
        case 'ANGEL_ONE':
            return BrokerId.ANGEL_ONE
        case 'UPSTOX':
            return BrokerId.UPSTOX
        case 'FYERS':
            return BrokerId.FYERS
        case 'PAPER_TRADING':
            return BrokerId.PAPER_TRADING
        case 'ZERODHA':
            return BrokerId.ZERODHA
        case 'DHAN':
            return BrokerId.DHAN
        default:
            return BrokerId.BROKER_UNKNOWN
    }
}

export const getBrokerImageType = (brokerCode: string): any => {
    switch (brokerCode) {
        case 'ANGEL_ONE':
            return 'img'
        case 'UPSTOX':
            return 'img'
        case 'FYERS':
            return 'img'
        case 'PAPER_TRADING':
            return 'svg'
        case 'ZERODHA':
            return 'img'
        case 'DHAN':
            return 'img'
        default:
            return ''
    }
}

export const getBrokerAddFundsUrl = (brokerCode: string): any => {
    switch (brokerCode) {
        case 'ANGEL_ONE':
            return 'https://www.angelone.in/trade/account/add-funds'
        case 'UPSTOX':
            return 'https://pro.upstox.com/funds/securities/wallet'
        case 'FYERS':
            return 'https://fundtransfer.fyers.in/v2/'
        case 'ZERODHA':
            return 'https://kite.zerodha.com/funds'
        case 'DHAN':
            return 'https://web.dhan.co/index/money'
        default:
            return ''
    }
}

export const jsonObjFromTradingAccountParams = (params: TradingAccount_TradingAccountParameter[]) => {
    const obj: any = {}
    params.forEach((param) => {
        obj[param.parameterName] = param.parameterValue
    })
    return obj
}

export const keyValueArrayFromTradingAccountParams = (params: TradingAccount_TradingAccountParameter[]) => {
    const obj: Params[] = []
    params.forEach((param) => {
        obj.push({
            key: param.parameterName,
            value: param.parameterValue
        })
    })
    return obj
}

export const generateBrokerLoginUrl = async (brokerCode: string, params: Params[]): Promise<string> => {
    const url = await getBrokerLoginUrl(
        {
            body: {
                brokerCode: brokerCode,
                params: [ ...params, ...((brokerCode === BrokerId.UPSTOX) ? convertMapToKeyValueArray({ 'redirectUri': getRedirectUrl('UPSTOX') }) : []) ]
            }
        }
    )
    if (url) {
        return url.loginUrl
    } else {
        return ''
    }
}